module.exports = __webpack_public_path__ + "static/knittedbowset-44c1811af3329045a7bbdea3af9cedff.jpeg";